/**
 * 契約プラン
 */
export const ContPlan = {
  // 無償
  無償: 0,
  // 有償
  有償: 1,
} as const;

export type ContPlanType = typeof ContPlan[keyof typeof ContPlan];
